import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initClientMonitoring } from './sentry';

// Kick Sentry off before React mounts so early render / import-time errors
// are captured. No-op when VITE_SENTRY_DSN is unset.
initClientMonitoring();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
